import React from "react";
import Footer from "../../Layout/Footer";
import Header from "../../Layout/Header";
import Home1 from "./Home1";

const HomePrivate = () => {
    return (
        <>
            <Header />
            <Home1 />            
            <Footer />
        </>
    );
}

export default HomePrivate

